module.exports = __webpack_public_path__ + "img/addressImg.9d242603.svg";